// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1YVoG","requiredAsterisk":"Info_requiredAsterisk__1U0G9"};